/* eslint-disable indent */
import { BookingSummaryCard } from '@ps-design-system/components/BookingSummaryCard';
import { ListingSummary } from '@ps-design-system/components/ListingSummary';
import { Text } from '@ps-design-system/components/Text';
import StarIcon from '@ps-design-system/icons/StarFilled/StarFilled16';
import PropTypes from 'prop-types';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { BookingRequestPriceSummary } from '../price-summaries/BookingRequestPriceSummary/BookingRequestPriceSummary';

export const BookingRequestSummaryCard = ({
  listing,
  isFetchingQuote,
  urlPrefix,
  accessToken,
  SSOid
}) => {
  return (
    <BookingSummaryCard
      listingSummary={
        <ListingSummary
          listing={listing}
          icons={
            <Text
              typeface="body-1"
              className="tw-text-gray-600"
              prefix={<StarIcon className="tw-text-gray-900" />}
            >
              <FormattedMessage
                id="booking_request_page.review_stars"
                defaultMessage="{stars} ({count}) Reviews"
                values={{
                  stars: listing?.space_review_stars,
                  count: listing?.space_review_count
                }}
              />
            </Text>
          }
        />
      }
      priceSummary={
        <BookingRequestPriceSummary
          urlPrefix={urlPrefix}
          accessToken={accessToken}
          SSOid={SSOid}
          showSkeleton={isFetchingQuote}
        />
      }
    />
  );
};

BookingRequestSummaryCard.propTypes = {
  listing: PropTypes.object,
  isFetchingQuote: PropTypes.bool,
  urlPrefix: PropTypes.string,
  accessToken: PropTypes.string,
  SSOid: PropTypes.string
};
